import { and, count, eq, type PowerSyncDrizzleDB, product } from "@stockpilot/powersync";
import { liveProductFilters } from "./filters";

/**
 * Cuenta los productos VIVOS de una organización en el SQLite local. Alimenta
 * `checkUnsyncedActor` (prompt «¿conservar datos locales?» al migrar de
 * invitado a cuenta real): antes hacía `count() from(product)` CRUDO en
 * `auth/controllers.ts`, contando también los de la papelera (bug de
 * invariante disperso — un producto borrado disparaba el prompt de "tienes
 * datos locales" aunque el catálogo visible estuviera vacío). Vía la capa live
 * solo cuenta vivos, coherente con el resto de vistas. (El merge
 * invitado→real corre igualmente vía `sweepVisitorData`, así que ninguna fila
 * se pierde; este contador solo decide si se MUESTRA el prompt.)
 */
export function getLiveProductCountForOrgQuery(db: PowerSyncDrizzleDB, orgId: string) {
  return db
    .select({ total: count() })
    .from(product)
    .where(and(eq(product.organization_id, orgId), ...liveProductFilters()));
}
